var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgreementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.50031C8.38254 6.26751 7.35362 6.7243 6.5 7.50031C6.16667 7.83365 5.4 8.50031 5 8.50031",
    stroke: "white",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.50031C8.38254 6.26751 7.35362 6.7243 6.5 7.50031C6.16667 7.83365 5.4 8.50031 5 8.50031",
    stroke: "black",
    strokeWidth: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4815 7L15.9577 6.57559C15.3369 6.14878 13.2805 5.52797 12 6.57559L7.92596 10.3005C7.57675 10.6497 7.44871 11.7904 8.33337 12.6285C9.13202 13.3851 10.0212 13.2105 10.3122 12.9777L12.9313 10.7661L16.4815 14.4328C16.8307 14.8984 17.3196 16.0158 16.4815 16.7608C15.6434 17.5058 14.1581 16.709 13.8476 16.4762C14.3715 17 14.3715 18.0476 13.3238 18.5714C12.2979 19.0844 11.7524 18.5714 11.0688 18.1576C10.6547 19.006 9.25295 19.7174 8.04236 18.5068C6.83177 17.2963 5.67551 16.1788 5.2487 15.7714C5.07409 15.6162 5.05873 15.5931 4.5 15.5",
    stroke: "white",
    strokeWidth: 1.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4815 7L15.9577 6.57559C15.3369 6.14878 13.2805 5.52797 12 6.57559L7.92596 10.3005C7.57675 10.6497 7.44871 11.7904 8.33337 12.6285C9.13202 13.3851 10.0212 13.2105 10.3122 12.9777L12.9313 10.7661L16.4815 14.4328C16.8307 14.8984 17.3196 16.0158 16.4815 16.7608C15.6434 17.5058 14.1581 16.709 13.8476 16.4762C14.3715 17 14.3715 18.0476 13.3238 18.5714C12.2979 19.0844 11.7524 18.5714 11.0688 18.1576C10.6547 19.006 9.25295 19.7174 8.04236 18.5068C6.83177 17.2963 5.67551 16.1788 5.2487 15.7714C5.07409 15.6162 5.05873 15.5931 4.5 15.5",
    stroke: "black",
    strokeWidth: 1.4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.9736,
    y: 6.95898,
    width: 3.02646,
    height: 10.127,
    stroke: "white",
    strokeWidth: 1.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9736,
    y: 6.95898,
    width: 3.02646,
    height: 10.127,
    stroke: "black",
    strokeWidth: 1.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6.95898,
    width: 3.02646,
    height: 10.127,
    stroke: "white",
    strokeWidth: 1.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6.95898,
    width: 3.02646,
    height: 10.127,
    stroke: "black",
    strokeWidth: 1.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8306 14.8223L19 14.8223",
    stroke: "white",
    strokeWidth: 1.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8306 14.8223L19 14.8223",
    stroke: "black",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreementIcon);
export default __webpack_public_path__ + "static/media/agreement-icon.2602dc730c3c279dc47a6d9ad87aabe4.svg";
export { ForwardRef as ReactComponent };